import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

/** 204 for any code; a valid one sets the browser-session referral cookie. */
export const recordReferralClick = async (code: string): Promise<void> => {
  return await request.post(`${URLS.BACK_DSH}${APIS.referralClicks}`, { code });
};
